import { Flex } from '@radix-ui/themes';
import React from 'react';
import CategoryFilter from './_filter/CategoryFilter';
import BudgetFilter from './_filter/BudgetFilter';
import AuctionSearch from './AuctionSearch';

interface Props {
  allCategories: string[];
}

const AuctionFilter = ({
  allCategories,
}: Props) => {
  return (
    <Flex direction="column" className="space-y-3">
      <Flex gap="2" align="center" className="flex-wrap">
        <CategoryFilter allCategories={allCategories} />
        <BudgetFilter />
        <AuctionSearch />
      </Flex>
    </Flex>
  );
}

export default AuctionFilter
